module.exports = __webpack_public_path__ + "img/7.4c217b2f.jpg";